
import React from 'react';

type ChevronsDownProps = {
  className?: string;
};

const ChevronsDown: React.FC<ChevronsDownProps> = ({ className }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      className={className}
    >
      <path d="m7 13 5 5 5-5" />
      <path d="m7 6 5 5 5-5" />
    </svg>
  );
};

export default ChevronsDown;
